"use strict";
exports.__esModule = true;
exports.REDUCER_ACTIONS = exports.COMMERCE_PLUS = void 0;
exports.COMMERCE_PLUS = {
    ENABLE_COMMERCE_PLUS: 'enableCommercePlus',
    BOT_NAME: 'botName',
    ENABLE_OVERRIDING_STAGING_URL: 'enableOverridingStagingURL',
    OVERRIDING_STAGING_URL: 'overridingStagingURL',
};
var SET_COMMERCE_DATA = 'SET_COMMERCE_DATA';
var SET_COMMERCE_DATA_EDITED = 'SET_COMMERCE_DATA_EDITED';
var SET_LOADER = 'SET_LOADER';
var ADD_TO_ERROR_LIST = 'ADD_TO_ERROR_LIST';
var REMOVE_FROM_ERROR_LIST = 'REMOVE_FROM_ERROR_LIST';
var SET_ERROR_LIST = 'SET_ERROR_LIST';
exports.REDUCER_ACTIONS = {
    SET_COMMERCE_DATA: SET_COMMERCE_DATA,
    SET_COMMERCE_DATA_EDITED: SET_COMMERCE_DATA_EDITED,
    SET_LOADER: SET_LOADER,
    ADD_TO_ERROR_LIST: ADD_TO_ERROR_LIST,
    REMOVE_FROM_ERROR_LIST: REMOVE_FROM_ERROR_LIST,
    SET_ERROR_LIST: SET_ERROR_LIST,
};
